// extracted by mini-css-extract-plugin
export default {"wrapper":"modelViewer__wrapper__BKURG","viewerWrapper":"modelViewer__viewerWrapper__EuSMV","error":"modelViewer__error__ZoRyS","arButton":"modelViewer__arButton__97jDz"};